import { render } from "./TemplateMfittSelectCoupon.vue?vue&type=template&id=134f8612"
import script from "./TemplateMfittSelectCoupon.vue?vue&type=script&lang=js"
export * from "./TemplateMfittSelectCoupon.vue?vue&type=script&lang=js"

import "./TemplateMfittSelectCoupon.vue?vue&type=style&index=0&id=134f8612&socped=true&lang=css"
script.render = render

export default script